export function asString(doc) {
    var _a;
    return (_a = ((doc === null || doc === void 0 ? void 0 : doc.loc) && doc.loc.source.body)) !== null && _a !== void 0 ? _a : '';
}
